namespace $.$$ {

	export function $shm_hitalama_map_float_toolbar_transform( zoom: number ) {
		return `translateY(-100%) scale(${ 1 / zoom })`
	}

	export function $shm_hitalama_map_float_resizer_transform( zoom: number ) {
		return `scale(calc(1 / ${ Math.min( 5, zoom ) }))`
	}

	export function $shm_hitalama_map_float_resizer_line_x_transform( zoom: number ) {
		return `scaleX(calc(1 / ${ Math.min( 5, zoom ) }))`
	}

	export function $shm_hitalama_map_float_resizer_line_y_transform( zoom: number ) {
		return `scaleY(calc(1 / ${ Math.min( 5, zoom ) }))`
	}

	export class $shm_hitalama_map_float extends $.$shm_hitalama_map_float {

		Map_page(): $.$$.$shm_hitalama_map_page {
			return super.Map_page() as $.$$.$shm_hitalama_map_page
		}

		zoom(): number {
			return this.Map_page().zoom()
		}

		repos_x( val: number ): number {
			return val / this.zoom()
		}

		repos_y( val: number ): number {
			return val / this.zoom()
		}

		pointerdown( event: PointerEvent ) {
			this.drag_pointerdown( event )
		}

		dragged(): ReturnType<ReturnType<$.$rise_resize[ "Drag_view" ]>[ "dragged" ]> {
			return this.Drag_view().dragged()
		}

		toolbar_transform() {
			return $shm_hitalama_map_float_toolbar_transform( this.zoom() )
		}

		zoom_for_resizers() {
			return Math.min( 5, this.zoom() )
		}

		resizer_transform() {
			return $shm_hitalama_map_float_resizer_transform( this.zoom() )
		}

		resizer_line_x_transform() {
			return $shm_hitalama_map_float_resizer_line_x_transform( this.zoom() )
		}

		resizer_line_y_transform() {
			return $shm_hitalama_map_float_resizer_line_y_transform( this.zoom() )
		}

	}

}
